import { jsPDF } from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import { CircularProgress, Grid, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import { gql, useLazyQuery } from "@apollo/client";
import EmpleadoLayout from "components/LayoutContainers/EmpleadoLayout";
import boxShadows from "assets/theme/base/boxShadows";
import EditableText from "components/EditableText";
import PdfHeader from "../components/pdfHeader";
import { formatMoneyPunto } from "utils/formatters";
import { formatDate } from "utils/formatters";

const textosIniciales = [
  "----/--",
  "CONCURSO",
  "....",
  "....",
  "30 días",
  "....",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "--/--/--",
  "....",
  "----/--",
  "UNIVERSIDAD PROVINCIAL DE OFICIOS \"EVA PERON\" ",
  "....-....-......",
  "0.00",
];

const ActivacionProcesoContratacion = () => {
  const documentsRef = useRef(null);
  const { id } = useParams();
  const { lg } = boxShadows;

  const [textArray, setTextArray] = useState(textosIniciales);
  const [editable, setEditable] = useState(true);

  const [data, setData] = useState(null);
  const [getPedido, { loading }] = useLazyQuery(
    gql`
      query getPedido($id: ID) {
        pedidosCompra(filter: { id: $id }) {
          id
          tipoCompra
          numeroExpediente
          fechaSolicitud
          licitacionInicio
          licitacionFin
          objetoCompra
          detalles{
            id
            numero
            materiaPrima{
              id
              nombre
              tipoUnidad {
                nombre
              }
            }
            cantidadVerificada
            observacion
            precioEstimado
            nombreServicio
          }
          proveedores{
            documento
            razonSocial
            nombre
            apellido
            habilitado
            user{
              email
            }
          }
        }
      }
    `,
    {
      onCompleted: (data) => {
        if (!data?.pedidosCompra[0]) return;
        setData(data.pedidosCompra[0]);
      },
    }
  );

  useEffect(() => {
    if (id) {
      getPedido({ variables: { id } });
    }
  }, [id]);

  useEffect(() => {
    if(data){
      const newTextArray = [...textArray];
      newTextArray[0] = data.id;
      newTextArray[1] = data.tipoCompra?.toUpperCase();
      newTextArray[2] = data.objetoCompra || "...";
      newTextArray[6] = formatDate(data.fechaSolicitud, "dd/MM/yyyy") || "--/--/--";
      newTextArray[8] = formatDate(data.licitacionInicio, "dd/MM/yyyy") || "--/--/--";
      newTextArray[9] = formatDate(data.licitacionFin, "dd/MM/yyyy") || "--/--/--";

      newTextArray[14] = data.id || "----/--";
      newTextArray[17] = "$ " + formatMoneyPunto(data.detalles.reduce((acc, detalle) => 
        acc + (detalle.cantidadVerificada * detalle.precioEstimado), 0
      ) || 0);


      setTextArray(newTextArray);
    }
  }, [data]);

  const handleGeneratePdf = async () => {
    setEditable(false);
    const document = documentsRef.current.childNodes[0];
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
      orientation: "portrait",
      hotfixes: ["px_scaling"],
      compress: true,
    });

    await doc.html(document, {
      margin: [50, 0, 50, 0],
      callback(doc) {
        doc.save(`exd-pedidoNro-${data.id}-activación-proceso-contratación.pdf`);
      },
    });
    setEditable(true);
  };

  const handleTextChange = (e, index) => {
    const newTextArray = [...textArray];
    newTextArray[index] = e.target.innerText;
    setTextArray(newTextArray);
  };

  if (!data) return (
    <EmpleadoLayout>
      <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh" flexDirection="column" gap={3}>
        {loading ? (<>
          <CircularProgress size={40} color="primary" />
          <SoftTypography variant="h5">Cargando</SoftTypography>
        </>) : (<>
          <Icon fontSize="large">search_off</Icon>
          <SoftTypography variant="h5">No se encontró el pedido</SoftTypography>
        </>)}
      </SoftBox>
    </EmpleadoLayout>
  );

  return (
    <EmpleadoLayout>
      <SoftBox
        p={2}
        display="flex"
        alignItems="center"
        flexDirection="column"
        minHeight="100vh"
        height="100%"
      >
        <div ref={documentsRef}>
          <SoftBox
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "794px",
              backgroundColor: "#ffffff",
              boxShadow: lg,
              px: 6,
            }}
            pb={5}
          >
            {/* ACA VA TODO EL CODIGO */}
            <PdfHeader />

            <SoftBox display="flex" flexDirection="column" gap={2}>
              <Grid container border="1pt solid black" lineHeight={1}>
                <Grid item px={6} py={1} xs={12} borderBottom="1pt solid black" textAlign="center">
                  <SoftTypography variant="caption" fontWeight="bold">
                    PROCESO DE CONTRATACIÓN N°:
                    <EditableText
                      tooltip="N° Proceso"
                      editable={editable}
                      content={textArray[0]}
                      handleOnBlur={(e) => handleTextChange(e, 0)}
                    /> - {" "}
                    <EditableText
                      tooltip="Tipo Proceso"
                      editable={editable}
                      content={textArray[1]}
                      handleOnBlur={(e) => handleTextChange(e, 1)}
                    /> DE PRECIOS OTROS ORGANISMOS
                  </SoftTypography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  borderRight="1pt solid black"
                  backgroundColor="rgba(230, 230, 230)"
                  pl={1}
                >
                  <SoftTypography variant="caption">Objeto</SoftTypography>
                </Grid>
                <Grid item xs={8} pl={1}>
                  <SoftTypography variant="caption">
                    <EditableText
                      tooltip="Objeto"
                      editable={editable}
                      content={textArray[2]}
                      handleOnBlur={(e) => handleTextChange(e, 2)}
                    />
                  </SoftTypography>
                </Grid>
              </Grid>

              <Grid container lineHeight={1} border="1pt solid black">
                <Grid item xs={7} container sx={{ '& > *:not(:nth-last-child(-n+2))': { borderBottom: "1pt solid black" } }}>
                  <Grid item xs={5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Método Adjudicación</SoftTypography>
                  </Grid>
                  <Grid item xs={7} px={1}>
                    <SoftTypography variant="caption">POR ITEM INDIVIDUAL AL MENOR PRECIO OFERTADO</SoftTypography>
                  </Grid>

                  <Grid item xs={5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Fecha Entrega</SoftTypography>
                  </Grid>
                  <Grid item xs={7} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Fecha Entrega"
                        editable={editable}
                        content={textArray[3]}
                        handleOnBlur={(e) => handleTextChange(e, 3)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Vigencia de Oferta</SoftTypography>
                  </Grid>
                  <Grid item xs={7} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Viegencia"
                        editable={editable}
                        content={textArray[4]}
                        handleOnBlur={(e) => handleTextChange(e, 4)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Precio Total de Solicitud</SoftTypography>
                  </Grid>
                  <Grid item xs={7} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Precio Total"
                        editable={editable}
                        content={textArray[5]}
                        handleOnBlur={(e) => handleTextChange(e, 5)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Consultas</SoftTypography>
                  </Grid>
                  <Grid item xs={7} px={1}>
                    <SoftTypography variant="caption">compras@uprosanluis.edu.ar</SoftTypography>
                  </Grid>
                </Grid>

                <Grid item xs={5} container borderLeft="1pt solid black" sx={{ '& > *:not(:nth-last-child(-n+2))': { borderBottom: "1pt solid black" } }}>
                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Publicación</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Publicación"
                        editable={editable}
                        content={textArray[6]}
                        handleOnBlur={(e) => handleTextChange(e, 6)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Límite de Preguntas</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Límite de Preguntas"
                        editable={editable}
                        content={textArray[7]}
                        handleOnBlur={(e) => handleTextChange(e, 7)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Inicio de Propuestas</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Inicio de Propuestas"
                        editable={editable}
                        content={textArray[8]}
                        handleOnBlur={(e) => handleTextChange(e, 8)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Fin de Propuestas</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Fin de Propuestas"
                        editable={editable}
                        content={textArray[9]}
                        handleOnBlur={(e) => handleTextChange(e, 9)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Fin de Aclaraciones</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Fin de Aclaraciones"
                        editable={editable}
                        content={textArray[10]}
                        handleOnBlur={(e) => handleTextChange(e, 10)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Apertura de Propuesta</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Apertura de Propuesta"
                        editable={editable}
                        content={textArray[11]}
                        handleOnBlur={(e) => handleTextChange(e, 11)}
                      />
                    </SoftTypography>
                  </Grid>

                  <Grid item xs={6.5} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Inicio de Evaluación</SoftTypography>
                  </Grid>
                  <Grid item xs={5.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Inicio de Evaluación"
                        editable={editable}
                        content={textArray[12]}
                        handleOnBlur={(e) => handleTextChange(e, 12)}
                      />
                    </SoftTypography>
                  </Grid>
                </Grid>

                <Grid container lineHeight={1} borderTop="1pt solid black">
                  <Grid item xs={2.92} px={1} backgroundColor="rgba(230, 230, 230)" borderRight="1pt solid black">
                    <SoftTypography variant="caption">Observaciones</SoftTypography>
                  </Grid>
                  <Grid item xs={9.08} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Observaciones"
                        editable={editable}
                        content={textArray[13]}
                        handleOnBlur={(e) => handleTextChange(e, 13)}
                      />
                    </SoftTypography>
                  </Grid>
                </Grid>
              </Grid>


              <Grid
                container
                border="1pt solid black"
                sx={{ '& > *:not(:last-child)': { borderBottom: "1pt solid black", backgroundColor: "rgba(230, 230, 230)" } }}
                lineHeight={1}
              >
                <Grid item xs={12} px={1}>
                  <SoftTypography variant="caption" fontWeight="bold">SOLICITUDES DE GASTOS INCLUÍDAS</SoftTypography>
                </Grid>

                <Grid item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                  <Grid item xs={2} px={1}>
                    <SoftTypography variant="caption">Número </SoftTypography>
                  </Grid>
                  <Grid item xs={4.5} px={1}>
                    <SoftTypography variant="caption">Unidad Ejecutora</SoftTypography>
                  </Grid>
                  <Grid item xs={2.5} px={1}>
                    <SoftTypography variant="caption">Expediente</SoftTypography>
                  </Grid>
                  <Grid item xs={3} px={1}>
                    <SoftTypography variant="caption">Monto</SoftTypography>
                  </Grid>
                </Grid>

                <Grid item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                  <Grid item xs={2} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Número"
                        editable={editable}
                        content={textArray[14]}
                        handleOnBlur={(e) => handleTextChange(e, 14)}
                      />
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={4.5} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Unidad Ejecutora"
                        editable={editable}
                        content={textArray[15]}
                        handleOnBlur={(e) => handleTextChange(e, 15)}
                      />
                    </SoftTypography>
                  </Grid>
                  <Grid item xs={3} px={1}>
                    <SoftTypography variant="caption">
                      <EditableText
                        tooltip="Monto"
                        editable={editable}
                        content={textArray[17]}
                        handleOnBlur={(e) => handleTextChange(e, 17)}
                      />
                    </SoftTypography>
                  </Grid>
                </Grid>

              </Grid>


              <Grid
                container
                border="1pt solid black"
                sx={{ 
                  '& > *:not(:last-child)': { borderBottom: "1pt solid black" },
                  '& > *:nth-child(-n+2)': { backgroundColor: "rgba(230, 230, 230)" }
                }}
                lineHeight={1}
              >
                <Grid item xs={12} px={1}>
                  <SoftTypography variant="caption" fontWeight="bold">PRODUCTOS O SERVICIOS REQUERIDOS</SoftTypography>
                </Grid>

                <Grid item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                  <Grid item xs={0.7} px={1}>
                    <SoftTypography variant="caption">N° </SoftTypography>
                  </Grid>
                  <Grid item xs={1} px={1}>
                    <SoftTypography variant="caption">Código</SoftTypography>
                  </Grid>
                  <Grid item xs={5.8} px={1}>
                    <SoftTypography variant="caption">Descripción</SoftTypography>
                  </Grid>
                  <Grid item xs={1.2} px={1}>
                    <SoftTypography variant="caption">Cantidad</SoftTypography>
                  </Grid>
                  <Grid item xs={1.2} px={1}>
                    <SoftTypography variant="caption">Unidad</SoftTypography>
                  </Grid>
                  <Grid item xs={2.1} px={1}>
                    <SoftTypography variant="caption">Precio Total Referencia</SoftTypography>
                  </Grid>
                </Grid>

                {data.detalles.map((detalle, index) => (
                  <Grid key={index} item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                    <Grid item xs={0.7} px={1}>
                      <SoftTypography variant="caption">{detalle.numero}</SoftTypography>
                    </Grid>
                    <Grid item xs={1} px={1}>
                      <SoftTypography variant="caption">{detalle.materiaPrima?.id || "0000"}</SoftTypography>
                    </Grid>
                    <Grid item xs={5.8} px={1}>
                      <SoftTypography variant="caption">{[detalle.nombreServicio, detalle.materiaPrima?.nombre, detalle.observacion].filter(e => e).join(" | ")}</SoftTypography>
                    </Grid>
                    <Grid item xs={1.2} px={1}>
                      <SoftTypography variant="caption">{detalle.cantidadVerificada || "-"}</SoftTypography>
                    </Grid>
                    <Grid item xs={1.2} px={1}>
                      <SoftTypography variant="caption">{detalle.materiaPrima?.tipoUnidad?.nombre || "-"}</SoftTypography>
                    </Grid>
                    <Grid item xs={2.1} px={1}>
                      <SoftTypography variant="caption">$ {formatMoneyPunto((detalle.cantidadVerificada * detalle.precioEstimado) || 0)}</SoftTypography>
                    </Grid>
                  </Grid>
                ))}

              </Grid>

              <Grid
                container
                border="1pt solid black"
                sx={{ 
                  '& > *:not(:last-child)': { borderBottom: "1pt solid black" },
                  '& > *:nth-child(-n+2)': { backgroundColor: "rgba(230, 230, 230)" }
                }}
                lineHeight={1}
              >
                <Grid item xs={12} px={1}>
                  <SoftTypography variant="caption" fontWeight="bold">INVITACIONES CURSADAS</SoftTypography>
                </Grid>

                <Grid item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                  <Grid item xs={2.5} px={1}>
                    <SoftTypography variant="caption">CUIT</SoftTypography>
                  </Grid>
                  <Grid item xs={4.5} px={1}>
                    <SoftTypography variant="caption">Razón Social</SoftTypography>
                  </Grid>
                  <Grid item xs={5} px={1}>
                    <SoftTypography variant="caption">Email</SoftTypography>
                  </Grid>
                </Grid>

                {data.proveedores.map((proveedor, index) => (
                  <Grid key={index} item xs={12} container sx={{ '& > *:not(:last-child)': { borderRight: "1pt solid black" } }}>
                    <Grid item xs={2.5} px={1}>
                      <SoftTypography variant="caption">{proveedor.documento} {!proveedor.habilitado && " (*)"}</SoftTypography>
                    </Grid>
                    <Grid item xs={4.5} px={1}>
                      <SoftTypography variant="caption">{(proveedor.razonSocial || `${proveedor.nombre} ${proveedor.apellido}`).toUpperCase()} </SoftTypography>
                    </Grid>
                    <Grid item xs={5} px={1}>
                      <SoftTypography variant="caption">{proveedor.user?.email}</SoftTypography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>

              <SoftTypography variant="caption">
                <strong>( * ) Proveedor Inhabilitado: </strong>Los proveedores inhabilitados NO pueden cotizar al momento de la generación del presente
                documento, éstos podrán realizarlo si regularizan su situación en el Registro de Proveedores del Estado.
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </div>
        <SoftBox
          variant="contained"
          bgColor="white"
          p={2}
          style={{
            position: "fixed",
            bottom: "1.5rem",
            right: "1.5rem",
            zIndex: 1000,
            boxShadow:
              "inset 0rem 0rem 0.0625rem 0.0625rem rgb(255 255 255 / 90%), 0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 5%)",
            borderRadius: "16px",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: `saturate(200%) blur(${pxToRem(30)})`,
          }}
        >
          <Grid container spacing={2} justifyContent="flex-end" id="button">
            <Grid item>
              <SoftButton variant="gradient" color="error" onClick={handleGeneratePdf}>
                <Icon fontWeight="bold">picture_as_pdf</Icon>
                &nbsp;&nbsp;Descargar PDF
              </SoftButton>
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </EmpleadoLayout>
  );
};

export default ActivacionProcesoContratacion;
